import BaseResource from './index'
import validators from '../utilities/validation'

function validateCity(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'City'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validateStateId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'State'
        throw validationError + '(' + validationError.field + ')'
    }
}

function validatePostal(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Postal'
        throw validationError + '(' + validationError.field + ')'
    }
}

export default class ProjectLocationResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/projectlocations'
}
